import { Flex } from '@grupoboticario/flora-react';

import { useResellerDetail } from 'hooks';
import { useLoyaltyIncentiveCampaign } from 'pages/IncentiveCampaign/hooks';

import Styles from './ResultsCampaignContent.styles';
import { Banner } from '../Banner';
import { CampaignContentSkeleton } from '../CampaignContent';
import { ChallengesResults } from '../ChallengesResults';
import { Orders } from '../Orders';
import { RankingResults } from '../RankingResults';
import { RedeemPrizes } from '../RedeemPrizes';
import { Reward } from '../Reward';
import { RulesDoubts } from '../RulesDoubts';

export const IncentiveCampaignResultsContent = () => {
  const { isLoading: isLoadingCampaign } = useLoyaltyIncentiveCampaign();
  const { data: resellerDetail, isLoading: isLoadingReseller } = useResellerDetail();
  const isLoyaltyMember = resellerDetail?.reseller.isLoyaltyMember ?? false;
  const isLoading = isLoadingCampaign || isLoadingReseller;
  if (isLoading) return <CampaignContentSkeleton />;

  return (
    <Styles.Wrapper>
      <Flex direction='column' gap='$15'>
        <Banner />
        <RedeemPrizes />
        <RankingResults />
        <Reward />
        {!isLoyaltyMember && <ChallengesResults />}
        <Orders />
        <RulesDoubts />
      </Flex>
    </Styles.Wrapper>
  );
};
